import { render, staticRenderFns } from "./self-test.vue?vue&type=template&id=4fd5dd77&scoped=true"
import script from "./self-test.vue?vue&type=script&lang=js"
export * from "./self-test.vue?vue&type=script&lang=js"
import style0 from "./self-test.vue?vue&type=style&index=0&id=4fd5dd77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5dd77",
  null
  
)

export default component.exports